import React, { useState, useEffect } from 'react';
import './style/ToggleSwitch.css';

const ToggleSwitch = ({ onToggle, initialValue = false }) => {
    const [isToggled, setIsToggled] = useState(initialValue);

    useEffect(() => {
        setIsToggled(initialValue);
    }, [initialValue]);

    const handleToggle = () => {
        const newToggledState = !isToggled;
        setIsToggled(newToggledState);
        if (onToggle) {
            onToggle(newToggledState);
        }
    };

    return (
        <div
            className={`toggle_switch ${isToggled ? 'toggled' : ''}`}
            onClick={handleToggle}
        >
            <div className={`switch_circle ${isToggled ? 'circle_toggled' : ''}`} />
        </div>
    );
};

export default ToggleSwitch;